module.exports = __webpack_public_path__ + "media/04 the Double Seventh Festival.d99df9f3.mp3";